// extracted by mini-css-extract-plugin
module.exports = {"table_operate":"index_table_operate_8mBQb","table_item_operate":"index_table_item_operate_Hrjnp","table_row_operate":"index_table_row_operate_Yh4XL"};